import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function GuidedTour(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M15.5 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 2a6.5 6.5 0 10-6.492-6.172L3.86 15.004a3.658 3.658 0 00-.387 4.12L2.296 20.29a1 1 0 001.408 1.42l1.181-1.171a3.658 3.658 0 004.13-.39l6.127-5.127.034-.03c.107.005.215.008.324.008zM5.395 16.285l4.208-5.047a6.526 6.526 0 003.166 3.162L7.73 18.616a1.657 1.657 0 01-2.336-2.331zm4.812-1.078a1 1 0 00-1.414-1.414l-1 1a1 1 0 101.414 1.414l1-1z",
    clipRule: "evenodd"
  }));
}

export default GuidedTour;